import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { SurveyAvailabilityBadge as SurveyAvailabilityBadgeVariant } from '../lib/instrument-info-state'
import {
  surveyEntryBadgeDotSx,
  surveyEntryBadgeDotUnavailableSx,
  surveyEntryBadgeSx,
  surveyEntryBadgeTextSx,
  surveyEntryBadgeTextUnavailableSx,
  surveyEntryBadgeUnavailableSx,
} from '../styles/surveyEntryStyles'

interface SurveyAvailabilityBadgeProps {
  readonly variant: SurveyAvailabilityBadgeVariant
}

export function SurveyAvailabilityBadge({ variant }: SurveyAvailabilityBadgeProps) {
  const available = variant === 'available'
  const label = available ? 'Survey available' : 'Survey unavailable'

  return (
    <Box
      sx={available ? surveyEntryBadgeSx : surveyEntryBadgeUnavailableSx}
      data-testid="survey-entry-badge"
      data-survey-available={available ? 'true' : 'false'}
    >
      <Box aria-hidden sx={available ? surveyEntryBadgeDotSx : surveyEntryBadgeDotUnavailableSx} />
      <Typography
        component="span"
        sx={available ? surveyEntryBadgeTextSx : surveyEntryBadgeTextUnavailableSx}
      >
        {label}
      </Typography>
    </Box>
  )
}
